import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class AdvancePaymentProofRequiredErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {},
            errors: [
                {
                    'code': 'cannot_close_an_advance_payment_order_without_advance_payment_proof',
                    'text': "cannot close an advance payment order without advance payment proof"
                }
            ]
        }
    }

    static errorCodes() {
        return ['cannot_close_an_advance_payment_order_without_advance_payment_proof'];
    }

    isAdvancePaymentRequiredError() {
        return true;
    }
}
